
(function() {
  var UNLOCK_ICON = '<svg class="fp-ship-bar__unlock" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="12" fill="#1F8A4C"/><rect x="7.3" y="11" width="9.4" height="7.2" rx="1.5" fill="#ffffff"/><path d="M9.2 11 V8.4 a2.8 2.8 0 0 1 5.4 -1.15" fill="none" stroke="#ffffff" stroke-width="1.7" stroke-linecap="round"/><circle cx="12" cy="14.3" r="1.05" fill="#1F8A4C"/></svg>';
const FREE_SHIP_BY_CURRENCY = {
    USD: 7500, EUR: 6500, GBP: 5500, CAD: 9900, AUD: 9900,
    NZD: 12900, CHF: 6000, JPY: 1200000, MXN: 134900,
    DKK: 49900, SEK: 74900, NOK: 69900, PLN: 28900, HUF: 2400000,
    RON: 34900, CZK: 160000, BGN: 12800
  };
  const KLARNA_INSTALLMENTS = 4;

  function getCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  }
  function getThreshold() {
    return FREE_SHIP_BY_CURRENCY[getCurrency()] || 7500;
  }
  function symbol() {
    const cur = getCurrency();
    const m = { USD:'$', EUR:'€', GBP:'£', CAD:'CA$', AUD:'A$', NZD:'NZ$', CHF:'CHF ', JPY:'¥', MXN:'MX$', DKK:'kr', SEK:'kr', NOK:'kr', PLN:'zł', HUF:'Ft', RON:'lei', CZK:'Kč', BGN:'лв' };
    return m[cur] || '$';
  }
  function formatMoney(cents) {
    const cur = getCurrency();
    const noDec = ['JPY','HUF','KRW'].includes(cur);
    const v = noDec ? String(Math.round(cents/100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : (cents/100).toFixed(2);
    const sym = symbol();
    if (cur === 'EUR' || cur === 'CHF' || ['DKK','SEK','NOK','PLN','HUF','RON','CZK','BGN'].includes(cur)) {
      return v + ' ' + sym.trim();
    }
    return sym + v;
  }

  async function getCart() { try { return await fetch('/cart.js').then(r => r.json()); } catch(e) { return null; } }

  // ===========================================================================
  //  CATEGORY ENGINE v2 — tag-driven (mirrors fp-pdp.js)
  //  Tags are the most reliable signal. Audited against full FP catalog.
  // ===========================================================================
  function categoryOf(prod) {
    let tagsRaw = prod && prod.tags;
    let tags = [];
    if (Array.isArray(tagsRaw)) tags = tagsRaw;
    else if (typeof tagsRaw === 'string') tags = tagsRaw.split(/\s*,\s*/);
    const T = tags.map(t => String(t || '').toLowerCase().trim());
    const has = t => T.indexOf(t) !== -1;
    const typeL = String((prod && prod.product_type) || '').toLowerCase().trim();
    const titleL = String((prod && prod.title) || '').toLowerCase();

    if (has('gift box')) return 'gift-set';
    if (has('grinders') || has('grinder')) return 'grinder';
    if (has('cleaning kit') || /care kit|cleaning|barista care/.test(titleL)) return 'care';
    if (has('scales') || /scale\b/.test(titleL)) return 'scale';
    if (has('milk frother') || /frother|whisk\b/.test(titleL)) return 'frother';
    if (has('storage') || /canister|cellar|bean (display|storage)/.test(titleL)) return 'storage';
    if (has('spoons') || /scoop|spoon|tamper/.test(titleL)) return 'spoon';
    if (has('french press') || /french press|cafetière|cafetiere|press mug/.test(titleL)) return 'french-press';
    if (has('moka') || /moka|stovetop|bialetti/.test(titleL)) return 'moka';
    if (/cold (brew|drip)|cold-?drip|cold-?brew|drip tower/.test(titleL)) return 'cold-brew';
    if (has('over') || /pour[- ]over|chemex|v60/.test(titleL)) return 'pour-over';
    if (/aeropress/.test(titleL)) return 'aeropress';
    if (has('manual') && has('espresso')) return 'manual-espresso';
    if (has('espresso') && has('maker')) return 'espresso-machine';
    if (has('kettles') || has('kettle') || /kettle|bouilloire|teapot/.test(titleL)) {
      if (has('tea') || /tea/.test(titleL)) return 'tea';
      return 'kettle';
    }
    if (has('espresso glass') || /espresso (cup|glass)|demitasse|cortado|tasting glass|espresso cup/.test(titleL)) return 'espresso-cup';
    if (has('coffee glass') || /tasting mug|fluted/.test(titleL)) return 'coffee-cup';
    if (has('mug') || /mug|tumbler|flask/.test(titleL)) return 'mug';
    if (has('drinkware')) return 'mug';

    if (/grinder|burr|mill/.test(typeL)) return 'grinder';
    if (/kettle/.test(typeL)) return /tea/.test(typeL) ? 'tea' : 'kettle';
    if (/frother|whisk/.test(typeL)) return 'frother';
    if (/scale/.test(typeL)) return 'scale';
    if (/storage|canister/.test(typeL)) return 'storage';
    if (/spoon|scoop/.test(typeL)) return 'spoon';
    if (/cleaning|care/.test(typeL)) return 'care';
    if (/french press/.test(typeL)) return 'french-press';
    if (/cafetière|cafetiere|pour|over/.test(typeL)) return 'pour-over';
    if (/moka/.test(typeL)) return 'moka';
    if (/cold/.test(typeL)) return 'cold-brew';
    if (/espresso/.test(typeL)) return 'espresso-machine';
    if (/mug|cup|drinkware|glass|tumbler/.test(typeL)) return 'mug';
    if (/gift|set|kit/.test(typeL)) return 'gift-set';
    return 'other';
  }

  const COMPLEMENTS = {
    'french-press':     ['grinder','kettle','scale','mug','care','spoon','storage','coffee-cup'],
    'pour-over':        ['grinder','kettle','scale','mug','care','spoon','storage','coffee-cup'],
    'aeropress':        ['grinder','kettle','mug','care','scale','spoon'],
    'moka':             ['grinder','frother','espresso-cup','mug','care'],
    'espresso-machine': ['grinder','frother','espresso-cup','scale','care','spoon'],
    'manual-espresso':  ['grinder','scale','espresso-cup','care'],
    'cold-brew':        ['grinder','scale','storage','mug','spoon'],
    'grinder':          ['french-press','pour-over','espresso-machine','moka','kettle','scale','storage','spoon'],
    'kettle':           ['french-press','pour-over','aeropress','grinder','scale','mug','coffee-cup'],
    'tea':              ['mug','coffee-cup','spoon','storage'],
    'scale':            ['grinder','kettle','french-press','pour-over','espresso-machine','spoon','storage'],
    'frother':          ['moka','espresso-machine','espresso-cup','mug','grinder'],
    'mug':              ['french-press','pour-over','grinder','kettle','spoon','storage'],
    'coffee-cup':       ['french-press','pour-over','grinder','kettle','spoon'],
    'espresso-cup':     ['espresso-machine','manual-espresso','moka','frother','grinder'],
    'storage':          ['grinder','scale','spoon','french-press','pour-over'],
    'spoon':            ['french-press','grinder','storage','scale','pour-over','kettle'],
    'care':             ['french-press','espresso-machine','grinder','pour-over','moka'],
    'gift-set':         ['grinder','scale','spoon','storage','care'],
    'other':            ['grinder','kettle','french-press','mug']
  };

  // Cached catalog (single fetch shared across drawer opens)
  let _catalogPromise = null;
  function fetchCatalog() {
    if (_catalogPromise) return _catalogPromise;
    _catalogPromise = fetch('/products.json?limit=250')
      .then(r => r.json())
      .then(d => (d && d.products) || [])
      .catch(() => []);
    return _catalogPromise;
  }

  async function getUpsellProducts(currentIds, currentProductId, limit, currentProductType, currentTitle) {
    limit = limit || 6;
    const catalog = await fetchCatalog();
    if (!catalog.length) return [];

    // Resolve current product (use first cart item) for accurate categoryOf
    let currentProd = null;
    if (currentProductId) {
      currentProd = catalog.find(p => p.id == currentProductId) || null;
    }
    if (!currentProd) {
      currentProd = { title: currentTitle || '', product_type: currentProductType || '', tags: [] };
    }
    const currentCat = categoryOf(currentProd);

    // Categories of OTHER items in the cart (avoid recommending what's already there's category)
    const cartCats = new Set([currentCat]);
    for (const id of currentIds) {
      const cp = catalog.find(p => p.id == id);
      if (cp) cartCats.add(categoryOf(cp));
    }

    const prefs = COMPLEMENTS[currentCat] || COMPLEMENTS['other'];

    const candidates = [];
    for (const p of catalog) {
      if (!p || !p.variants || !p.variants.length) continue;
      if (p.published_at === null) continue;
      if (currentIds.includes(p.id)) continue;
      const cat = categoryOf(p);
      if (cat === currentCat) continue;          // never competing with main item
      const idx = prefs.indexOf(cat);
      if (idx === -1) continue;                   // not a real complement
      // Slight penalty if its category is already in the cart (already bought)
      const inCartPenalty = cartCats.has(cat) ? 100 : 0;
      candidates.push({ p, cat, score: idx + inCartPenalty });
    }

    candidates.sort((a, b) => {
      if (a.score !== b.score) return a.score - b.score;
      return new Date(b.p.updated_at || 0) - new Date(a.p.updated_at || 0);
    });

    // Diversify: max 2 per category in cart drawer (8 slots so 2x4 tops)
    const perCat = {};
    const out = [];
    for (const c of candidates) {
      if (out.length >= limit) break;
      perCat[c.cat] = (perCat[c.cat] || 0) + 1;
      if (perCat[c.cat] > 2) continue;
      out.push(c.p);
    }
    return out;
  }

  function buildShipDone() {
    return '<div class="fp-ship-done" data-fp-ship-bar><svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#1F7A4D"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Free shipping unlocked</span></div>';
  }
  // 30/09/26 : bas du tiroir façon Atlas : livraison + TOTAL avec le montant, juste au-dessus du bouton
  // montant au format du pays du visiteur (149,00 € en FR, $149.00 aux US), comme les prix des lignes
  /*AVRIL-I18N*/ function fpT(k, v) { const d = window.FP_CART_T || {}; let t = d[k] || ({ bag: 'Your bag', checkout: 'Secure checkout', free: 'Free shipping', arrives: 'Arrives', add_for: 'Add [amount] for free shipping', shipping: 'Shipping', shipping_free: 'Free', calc: 'Calculated at checkout', total: 'Total', discount: 'Ritual pair discount' })[k] || k; if (v) Object.keys(v).forEach(x => { t = t.split('[' + x + ']').join(v[x]); }); return t; }
  function fpTotalMoney(cents) {
    try { const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; const loc = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en-US';
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); } catch (e) { return formatMoney(cents); }
  }
  /*AVRIL-TIROIR*/ function fpEtaRange() { return ''; /* 10/10/26 Mathéo : délais retirés (test) */ try { const lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en-US'; const fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', month: 'short', day: 'numeric' }); const add = (n) => { const x = new Date(); x.setDate(x.getDate() + n); while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1); return x; }; return fmt.format(add(6)) + ' – ' + fmt.format(add(10)); } catch (e) { return ''; } }
  function buildHeadLine(total) {
    const threshold = getThreshold(); const remaining = Math.max(0, threshold - total); const reached = remaining === 0 && total > 0; const r = fpEtaRange();
    const truck = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
    const lead = reached ? '<strong>' + fpT('free') + '</strong>' : '<span class="fp-head-line__lead">' + fpT('add_for', { amount: '<strong>' + fpTotalMoney(remaining) + '</strong>' }) + '</span>'; // phrase entière traduisible (une partie protégée cassait la traduction FR)
    return '<div class="fp-head-line notranslate' + (reached ? ' fp-head-line--done' : '') + '" translate="no" data-fp-ship-bar data-fp-eta-line>'
      + '<p class="fp-head-line__text">' + truck + '<span>' + lead + (r ? '<span class="fp-head-line__sep" aria-hidden="true">·</span>' + fpT('arrives') + '<strong class="notranslate fp-head-line__nt" translate="no">' + r + '</strong>' : '') + '</span></p>'
      + (reached ? '' : '<div class="fp-head-line__track"><div class="fp-head-line__fill" style="width:' + Math.min(100, total / threshold * 100) + '%"></div></div>')
      + '</div>';
  }
  function fpRitualSave(cart) { let s = 0; ((cart && cart.items) || []).forEach(i => (i.line_level_discount_allocations || []).forEach(d => { if (d.amount > 0 && /Complete your ritual/.test((d.discount_application && d.discount_application.title) || '')) s += d.amount; })); return s; }
  function buildTotals(total, cart) {
    const free = total >= getThreshold(); const save = fpRitualSave(cart);
    return '<div class="fp-totals notranslate" translate="no" data-fp-totals>'
      + (save > 0 ? '<div class="fp-totals__row fp-totals__row--save" data-fp-avril-cart-offer="applied" data-save="' + save + '" data-currency="' + ((cart && cart.currency) || '') + '"><span>' + fpT('discount') + '</span><span class="notranslate" translate="no">−' + fpTotalMoney(save) + '</span></div>' : '')
      + '<div class="fp-totals__row"><span>' + fpT('shipping') + '</span>' + (free ? '<span class="fp-totals__free">&#10003; ' + fpT('shipping_free') + '</span>' : '<span class="fp-totals__muted">' + fpT('calc') + '</span>') + '</div>'
      + '<div class="fp-totals__row fp-totals__row--total"><span>' + fpT('total') + '</span><strong class="notranslate" translate="no">' + fpTotalMoney(total) + '</strong></div>'
      + '</div>';
  }

  function buildShipBar(total) {
    const threshold = getThreshold();
    const remaining = Math.max(0, threshold - total);
    const progress = Math.min(100, (total / threshold) * 100);
    const reached = remaining === 0 && total > 0;
    const text = reached ? '<strong>Free shipping unlocked</strong>' + UNLOCK_ICON
      : 'Add <strong>' + formatMoney(remaining) + '</strong> for <strong>free shipping</strong>';
    return '<div class="fp-ship-bar' + (reached ? ' fp-ship-bar--done' : '') + '" data-fp-ship-bar><div class="fp-ship-bar__text">' + text + '</div><div class="fp-ship-bar__track"><div class="fp-ship-bar__fill" style="width:' + progress + '%"></div></div></div>';
  }

  function getCountdownText() {
    const now = new Date();
    const next = new Date(now);
    const nh = (Math.floor(now.getHours() / 6) + 1) * 6;
    if (nh >= 24) { next.setDate(next.getDate() + 1); next.setHours(0,0,0,0); } else { next.setHours(nh,0,0,0); }
    const diff = Math.max(0, next - now);
    return Math.floor(diff/3600000) + 'h ' + Math.floor((diff%3600000)/60000) + 'min ' + Math.floor((diff%60000)/1000) + 's';
  }

  function buildCountdown() {
    // FP V3 — Lynore translation patch: wrap the dynamic time digits in
    // class="notranslate" translate="no" so Google Translate / Shopify Markets
    // doesn't re-translate the live ticker (which breaks formatting).
    return '<div class="fp-countdown" data-fp-countdown><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><span><strong>Tracked delivery</strong> · tracking included</span></div>';
  }

  // 30/09/26 (Mathéo) : date de livraison estimée en bas du tiroir, juste au-dessus du total, comme Atlas.
  // Même calcul que la fiche produit et qu'Atlas : commande + 6 à 10 jours (calendaires), demande Mathéo 30/09.
  function fpEtaAddBusinessDays(n) { const x = new Date(); while (n > 0) { x.setDate(x.getDate() + 1); const wd = x.getDay(); if (wd !== 0 && wd !== 6) n--; } return x; }
  function buildEta() {
    return ''; // 10/10/26 Mathéo : délais retirés (test)
    try {
      const lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en-US';
      const fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', month: 'short', day: 'numeric' });
      const add = (n) => { const x = new Date(); x.setDate(x.getDate() + n); while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1); return x; }; // 05/10/26 jamais un week-end (fp-express-checkout-2026-10-05)
      const r = fmt.format(add(6)) + ' – ' + fmt.format(add(10));
      return '<div class="fp-eta-line" data-fp-eta-line><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg><span>Order today, estimated delivery&nbsp;<strong class="notranslate" translate="no">' + r + '</strong></span></div>';
    } catch (e) { return ''; }
  }

  function buildTrust() {
    return '<div class="fp-cart-trust" data-fp-cart-trust>'
      + '<div class="fp-cart-trust__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg><span>1-year guarantee</span></div>'
      + '<div class="fp-cart-trust__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg><span>Secure checkout</span></div>'
      + '<div class="fp-cart-trust__item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/></svg><span>35+ countries</span></div>'
      + '</div>';
  }

  function buildKlarna(total) {
    const inst = total / KLARNA_INSTALLMENTS;
    return '<div class="fp-klarna" data-fp-klarna><span class="fp-klarna__brand">Klarna<span class="fp-klarna__dot">.</span></span><span class="fp-klarna__text">' + KLARNA_INSTALLMENTS + ' interest-free payments of <strong>' + formatMoney(inst) + '</strong>.</span></div>';
  }

  function buildUpsellCard(product) {
    if (!product) return '';
    const variant = product.variants[0];
    const imgRaw = (product.images && product.images[0]) || product.featured_image || '';
    const img = typeof imgRaw === 'object' && imgRaw !== null ? (imgRaw.src || imgRaw.url || '') : imgRaw;
    // Robust price parsing (handles "29.00" string and 2900 integer)
    function toCents(v) {
      if (v == null || v === '') return 0;
      const s = String(v);
      return s.indexOf('.') >= 0 ? Math.round(parseFloat(s) * 100) : (parseInt(s, 10) || 0);
    }
    const cents = toCents(variant.price);
    const cmpCents = toCents(variant.compare_at_price);
    const onSale = cmpCents > cents && cents > 0;
    const pct = onSale ? Math.round((1 - cents / cmpCents) * 100) : 0;

    const url = (window.Shopify.routes.root + 'products/') + product.handle;
    const priceHTML = onSale
      ? '<div class="fp-upsell__price fp-upsell__price--sale"><s>' + formatMoney(cmpCents) + '</s> <strong>' + formatMoney(cents) + '</strong></div>'
      : '<div class="fp-upsell__price">' + formatMoney(cents) + '</div>';
    const badgeHTML = onSale
      ? '<span class="fp-upsell__badge">-' + pct + '%</span>'
      : '';

    return '<div class="fp-upsell__slide">'
      + '<a href="' + url + '" class="fp-upsell__media-link" aria-label="' + product.title + '">'
      +   '<div class="fp-upsell__media">'
      +     badgeHTML
      +     (img ? '<img src="' + img + '" alt="' + product.title + '" loading="lazy" />' : '')
      +   '</div>'
      + '</a>'
      + '<a href="' + url + '" class="fp-upsell__name">' + product.title + '</a>'
      + priceHTML
      + '<button type="button" class="fp-upsell__add" data-variant-id="' + variant.id + '">+ Add</button>'
      + '</div>';
  }
  function buildUpsell(products) {
    if (!products || !products.length) return '';
    const slides = products.map(buildUpsellCard).join('');
    return '<div class="fp-upsell" data-fp-upsell><div class="fp-upsell__head"><div class="fp-upsell__title">You may also like</div><div class="fp-upsell__nav"><button type="button" class="fp-upsell__arrow" data-fp-upsell-prev aria-label="Previous">‹</button><button type="button" class="fp-upsell__arrow" data-fp-upsell-next aria-label="Next">›</button></div></div><div class="fp-upsell__track" data-fp-upsell-track>' + slides + '</div></div>';
  }function findDialog() { return document.querySelector('cart-drawer-component dialog'); }

  let injectingNow = false;
  async function injectIntoDrawer() {
    if (injectingNow) return;
    injectingNow = true;
    setTimeout(() => { injectingNow = false; }, 120);

    const dlg = findDialog();
    if (!dlg) return;
    const cart = await getCart();
    if (!cart) return;
    const total = cart.total_price;
    const isEmpty = cart.item_count === 0;

    // Renames
    const heading = dlg.querySelector('.cart-drawer__heading');
    if (heading) {
      heading.childNodes.forEach(n => {
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim() === 'Cart') n.nodeValue = ' ' + fpT('bag') + ' ';
      });
    }
    const checkoutBtn = dlg.querySelector('#checkout, button[name="checkout"], .cart__checkout-button');
    if (checkoutBtn) {
      const span = checkoutBtn.querySelector('.button-text, span');
      if (span) span.textContent = fpT('checkout');
    }

    // Cleanup old fp injections
    dlg.querySelectorAll('[data-fp-ship-bar],[data-fp-cart-trust],[data-fp-klarna],[data-fp-upsell],[data-fp-countdown],[data-fp-eta-line],[data-fp-totals]').forEach(el => el.remove());

    // Inject ship bar + countdown only when cart has items
    const headerWrap = dlg.querySelector('.cart-drawer__header');
    if (headerWrap && !isEmpty) {
      // 30/09/26 (Mathéo) : plus de « Delivered in 6 to 10 business days » ni de « Free shipping unlocked » en haut ; la barre reste tant que le seuil n'est pas atteint
      headerWrap.insertAdjacentHTML('afterend', buildHeadLine(total)); /*AVRIL-TIROIR : une seule ligne fine (livraison + date) */
    }

    if (!isEmpty) {
      // 30/09/26 (Mathéo) : « You may also like » retiré du tiroir ; bouton « Secure checkout » sans le montant ;
      // date de livraison estimée juste au-dessus du total.
      if (checkoutBtn) {
        const labelEl = checkoutBtn.querySelector('.button-text') || checkoutBtn.querySelector('span:not([class*="icon"])');
        if (labelEl) labelEl.innerHTML = fpT('checkout') + '<span class="fp-ck-amt notranslate" translate="no"> · ' + fpTotalMoney(total) + '</span>'; /* 14/10/26 Mathéo : montant dans le bouton, ligne Total retirée */
      }
      const ctas = dlg.querySelector('.cart__ctas');
      if (ctas) ctas.insertAdjacentHTML('beforebegin', buildTotals(total, cart));
      // FP V3 — Klarna and trust badges removed from drawer per user request
    }

    // Final dedup
    ['[data-fp-ship-bar]','[data-fp-cart-trust]','[data-fp-klarna]','[data-fp-upsell]','[data-fp-countdown]','[data-fp-eta-line]','[data-fp-totals]'].forEach(sel => {
      const els = dlg.querySelectorAll(sel);
      els.forEach((el, i) => { if (i > 0) el.remove(); });
    });

    // FP V3 — Anti-FOUC: mark dialog as ready so CSS can swap pre-styled placeholders
    // for the real (now-customized) UI. Also flag the checkout button so its baseline
    // CSS pseudo-element ("Secure checkout") releases and the JS-set text shows.
    dlg.setAttribute('data-fp-ready', '1');
    if (checkoutBtn) checkoutBtn.setAttribute('data-fp-checkout-final', '1');
  }

  // Live countdown updater
  setInterval(() => {
    const el = document.querySelector('[data-fp-countdown-time]');
    if (el) el.textContent = getCountdownText();
  }, 1000);

  // Upsell click
  // Carousel arrow nav
  document.addEventListener('click', e => {
    const prev = e.target.closest('[data-fp-upsell-prev]');
    const next = e.target.closest('[data-fp-upsell-next]');
    if (prev || next) {
      const track = (prev || next).closest('.fp-upsell').querySelector('[data-fp-upsell-track]');
      if (track) {
        const slide = track.querySelector('.fp-upsell__slide');
        const step = slide ? slide.getBoundingClientRect().width + 12 : 162;
        track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
      }
    }
  });

  document.addEventListener('click', async e => {
    const btn = e.target.closest('.fp-upsell__add');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id, quantity: 1 }) });
      btn.textContent = 'Added';
      setTimeout(() => window.location.reload(), 600);
    } catch(err) { btn.textContent = 'Error'; btn.disabled = false; }
  });

  let lastOpen = false;
  setInterval(() => {
    const dlg = findDialog();
    const open = dlg && dlg.open;
    if (dlg && !dlg.__fpObs) { dlg.__fpObs = true; var _fpReinjectT; new MutationObserver(function(){ if (dlg.open && !dlg.querySelector('[data-fp-ship-bar]')) { clearTimeout(_fpReinjectT); _fpReinjectT = setTimeout(injectIntoDrawer, 60); } }).observe(dlg, { childList: true, subtree: true }); }
    if (open && !lastOpen) {
      setTimeout(injectIntoDrawer, 50);
      setTimeout(injectIntoDrawer, 300);
    }
    if (open && !dlg.querySelector('[data-fp-ship-bar]')) injectIntoDrawer();
    lastOpen = open;
  }, 500);

  ['cart:updated','cart:refresh','cart:change','cart:add','cart:item:update'].forEach(evt => {
    document.addEventListener(evt, () => setTimeout(injectIntoDrawer, 100));
  });

  // === FP V3 — Standalone /cart page enhancements ===
  async function enhanceCartPage() {
    const page = document.querySelector('.cart-page, .template-cart');
    if (!page) return;
    const cart = await getCart();
    if (!cart) return;
    const total = cart.total_price;
    const isEmpty = cart.item_count === 0;

    // Rename heading "Cart" -> "Your bag"
    page.querySelectorAll('h1').forEach(h => {
      const tn = [...h.childNodes].find(n => n.nodeType === 3 && n.nodeValue && n.nodeValue.trim() === 'Cart');
      if (tn) tn.nodeValue = ' ' + fpT('bag') + ' ';
    });

    // Rename checkout button -> "Secure checkout"
    const ckBtn = page.querySelector('.cart__checkout-button, [name="checkout"]');
    if (ckBtn) {
      const span = ckBtn.querySelector('.button-text, span');
      if (span) span.textContent = fpT('checkout');
    }

    // Cleanup prior fp injections
    page.querySelectorAll('[data-fp-page-shipbar],[data-fp-page-klarna],[data-fp-page-trust]').forEach(e => e.remove());
    if (isEmpty) return;

    // Ship bar — at top of cart-items area
    const itemsTop = page.querySelector('.cart-items, .cart-items__wrapper, .cart-items__table');
    if (itemsTop) {
      const threshold = getThreshold();
      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, (total / threshold) * 100);
      const reached = remaining === 0 && total > 0;
      const txt = reached ? '<strong>Free shipping unlocked</strong>' + UNLOCK_ICON
        : 'Add <strong>' + formatMoney(remaining) + '</strong> for <strong>free shipping</strong>';
      itemsTop.insertAdjacentHTML('beforebegin',
        '<div class="fp-cart-page-shipbar' + (reached ? ' fp-ship-bar--done' : '') + '" data-fp-page-shipbar>'
        + '<div class="fp-ship-bar__text">' + txt + '</div>'
        + '<div class="fp-ship-bar__track"><div class="fp-ship-bar__fill" style="width:' + progress + '%"></div></div>'
        + '</div>'
      );
    }

    // Klarna BELOW checkout button (no more trust badges per user request)
    if (ckBtn && ckBtn.parentNode) {
      const klarna = '<div data-fp-page-klarna>' + (window.amtBnplHtml ? window.amtBnplHtml(total) : '') + '</div>'; /* amt-bnpl-1610 : par pays */
      ckBtn.insertAdjacentHTML('afterend', klarna);
    }
  }

  // Run on /cart pages
  if (document.querySelector('.cart-page, .template-cart')) {
    setTimeout(enhanceCartPage, 100);
    document.addEventListener('cart:updated', () => setTimeout(enhanceCartPage, 100));
    document.addEventListener('cart:refresh', () => setTimeout(enhanceCartPage, 100));
  }

})();

/* 13/10/26 (Mathéo) : « tout se fait avec le tiroir ».
   1) Les formulaires « Add to cart » que le thème ne gère pas lui-même (ex. section d'accueil fp3-chapters) ajoutaient puis envoyaient sur /cart :
      on ajoute en arrière-plan, on met le tiroir à jour (événement cart:update, comme fp-avril-cart.js) et on l'ouvre.
   2) La page /cart n'est plus utilisée : retour à la page précédente du site (ou l'accueil) avec le tiroir ouvert (?fp_cart=1). */
(function () {
  if (window.__fpDrawerOnly) return; window.__fpDrawerOnly = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var path = location.pathname.replace(/\/$/, '');
  if (/\/cart$/.test(path)) {
    var back = root;
    try { var r = document.referrer && new URL(document.referrer); if (r && r.origin === location.origin && !/\/cart\/?$|\/checkouts?\//.test(r.pathname)) back = r.pathname + r.search; } catch (e) {}
    location.replace(back + (back.indexOf('?') < 0 ? '?' : '&') + 'fp_cart=1');
    return;
  }
  function drawer() { return document.querySelector('cart-drawer-component'); }
  function openDrawer() { var d = drawer(); if (d && typeof d.open === 'function') { d.open(); return true; } var b = document.querySelector('cart-drawer-component .header-actions__action, [aria-label="Cart"]'); if (b) { b.click(); return true; } return false; }
  if (/[?&]fp_cart=1/.test(location.search)) {
    try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])fp_cart=1&?/, '$1').replace(/[?&]$/, '') + location.hash); } catch (e) {}
    var tries = 0; (function wait() { /* le tiroir n'est prêt qu'après son initialisation : on réessaie jusqu'à ce qu'il soit vraiment ouvert */
      var d = drawer(), dl = d && d.querySelector('dialog'); if (dl && dl.open) return;
      try { if (d && d.refs && d.refs.dialog) d.open(); } catch (e) {}
      if (tries++ < 40) setTimeout(wait, 250); })();
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || !drawer()) return;
    if (f.closest('product-form-component, cart-drawer-component, dialog')) return; /* le thème gère déjà ceux-là */
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    var fd = new FormData(f);
    var ids = [].map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (c) { return c.dataset.sectionId; }).join(',');
    if (ids) fd.append('sections', ids);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || 'add');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'fp-drawer-only', data: { source: 'fp-drawer-only', itemCount: 1, sections: res.sections || undefined } };
          document.dispatchEvent(ev);
          setTimeout(openDrawer, 120);
        });
      })
      .catch(function () { f.submit(); }) /* en cas d'échec : comportement d'origine */
      .then(function () { if (btn) btn.disabled = false; });
  }, true);
})();


/* 14/10/26 (Mathéo) : le menu déroulant de quantité du tiroir envoie la valeur au composant quantité du thème (même mise à jour qu'avec + / −) */
(function () { if (window.__fpQtySel) return; window.__fpQtySel = true;
  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest && e.target.closest('[data-fp-qty-line]'); if (!s) return;
    var row = s.closest('.cart-items__quantity-controls'); var inp = row && row.querySelector('input[data-cart-line]'); var comp = inp && inp.closest('cart-quantity-selector-component');
    if (!inp || !comp || typeof comp.onQuantityChange !== 'function') return;
    inp.value = s.value; comp.onQuantityChange(); try { comp.updateButtonStates(); } catch (x) {}
  });
})();


/* 14/10/26 (Mathéo, option A) : nombre d'articles à côté du titre du tiroir (« · 1 item », traduit) */
(function () { if (window.__fpBandA) return; window.__fpBandA = true;
  var W = { en: ['item', 'items'], fr: ['article', 'articles'], de: ['Artikel', 'Artikel'], es: ['artículo', 'artículos'], it: ['articolo', 'articoli'], nl: ['artikel', 'artikelen'], pt: ['artigo', 'artigos'] };
  function run() { var h = document.querySelector('cart-drawer-component .cart-drawer__heading'); if (!h) return;
    var c = document.querySelector('cart-drawer-component .cart-bubble__text-count'); var n = parseInt((c && c.textContent) || '0', 10) || 0;
    var l = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase(); var w = W[l] || W.en;
    var v = n > 0 ? '· ' + n + ' ' + (n > 1 ? w[1] : w[0]) : ''; if (h.getAttribute('data-fp-count') !== v) { if (v) h.setAttribute('data-fp-count', v); else h.removeAttribute('data-fp-count'); } }
  setInterval(run, 400); run();
})();
